// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/** RentAll - Begin **/
.ReportUserModal-logInModalContainer-eSyKC {
  max-width: 468px;
  width: 100%;
  margin: 160px auto;
}
.ReportUserModal-logInModalBody-x4hKm {
  padding: 25px;
}
@media screen and (max-width: 767px) {
  .ReportUserModal-logInModalContainer-eSyKC {
    margin: 0px auto;
    padding: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ReportUserModal/ReportUserModal.css"],"names":[],"mappings":"AAAA,sBAAsB;AACtB;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;AAEA;EACE,aAAa;AACf;AAEA;EACE;IACE,gBAAgB;IAChB,aAAa;EACf;AACF","sourcesContent":["/** RentAll - Begin **/\n.logInModalContainer {\n  max-width: 468px;\n  width: 100%;\n  margin: 160px auto;\n}\n\n.logInModalBody {\n  padding: 25px;\n}\n\n@media screen and (max-width: 767px) {\n  .logInModalContainer {\n    margin: 0px auto;\n    padding: 10px;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"logInModalContainer": `ReportUserModal-logInModalContainer-eSyKC`,
	"logInModalBody": `ReportUserModal-logInModalBody-x4hKm`
};
module.exports = ___CSS_LOADER_EXPORT___;
